import type { HeroProps } from '@/components/PolicyTwo/Hero';
import { sharedConfig } from '@/pageConfig/shared';
import og from '@/static/assets/transparency/transparency_report_og.png';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/PolicyTwo/policyTwo__fr-FR.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export interface Config extends BasePageConfig {
  hero: HeroProps;
}

export const config: Config = {
  layout: { ...sharedConfig['fr-FR'].layout, showAskUsAnything: true },
  seo: {
    ...sharedConfig['fr-FR'].seo,
    title: "La Police d'Assurance 2.0 | Assurance Lemonade à partir de 4 €/mois",
    description:
      "La Police 2.0 par Lemonade: Une police d'assurance simplifiée, modernisée et numérisée. Découvrez la première police d'assurance open source au monde.",
    ogImage: og.src,
  },
  hero: {
    title: 'La Première Police\nOpen Source au Monde',
    subtitle:
      "La Police 2.0 est une police d'assurance radicalement simplifiée, modernisée et numérisée. Ça veut dire que vous pouvez réellement la lire et la comprendre !",
    ctaLabel: "lire la police d'assurance",
  },
  MDXContent: content as DocumentTypes,
};
